import React from 'react';
import { Link } from 'react-router-dom';
import { NewTabHint } from './NewTabHint';
type Variant = 'primary' | 'secondary' | 'onDark' | 'ghost';
const styles: Record<Variant, string> = {
  primary: 'bg-brand-navy text-white border-2 border-brand-navy hover:bg-[#083a7c] hover:border-[#083a7c]',
  secondary: 'bg-white text-brand-navy border-2 border-brand-navy hover:bg-brand-tan',
  onDark: 'bg-brand-yellow text-[#3d2b00] border-2 border-brand-yellow hover:bg-[#f7d454] hover:border-[#f7d454]',
  ghost: 'bg-transparent text-brand-navy border-2 border-transparent underline underline-offset-4 hover:border-brand-navy hover:no-underline'
};
const shared = 'inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full px-6 py-3 text-center font-display text-[15px] font-semibold leading-snug transition-all duration-150 hover:-translate-y-0.5 active:translate-y-0 sm:text-base';
type CommonProps = {
  variant?: Variant;
  className?: string;
  children: React.ReactNode;
};
export function Button({
  variant = 'primary',
  className = '',
  children,
  ...props
}: CommonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type="button" className={`${shared} ${styles[variant]} ${className}`} {...props} data-id="element-336" data-mp="es0r11vhnbyl">
      {children}
    </button>;
}
export function ButtonLink({
  to,
  variant = 'primary',
  className = '',
  children
}: CommonProps & {
  to: string;
}) {
  return <Link to={to} className={`${shared} ${styles[variant]} ${className}`} data-id="element-337" data-mp="12m0oz1wyzcz5">
      {children}
    </Link>;
}
export function ButtonExternal({
  href,
  variant = 'primary',
  className = '',
  children
}: CommonProps & {
  href: string;
}) {
  const isMailto = href.startsWith('mailto:');
  return <a href={href} {...isMailto ? {} : {
    target: '_blank',
    rel: 'noopener noreferrer'
  }} className={`${shared} ${styles[variant]} ${className}`} data-id="element-338" data-mp="17fmuma4puglg">
      {children}
      {isMailto ? null : <NewTabHint data-id="element-339" data-mp="1he2h1zsst1om" />}
    </a>;
}
export function ButtonAnchor({
  href,
  variant = 'primary',
  className = '',
  children
}: CommonProps & {
  href: string;
}) {
  return <a href={href} className={`${shared} ${styles[variant]} ${className}`} data-id="element-340" data-mp="1tfu2swuiahpn">
      {children}
    </a>;
}